import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import RevisionsListItem from "editor/components/RevisionsList/RevisionsListItem";
import ComponentWithRevisions, {
  mapStateToProps,
  mapDispatchToProps,
} from "editor/utils/ComponentWithRevisions";
import styles from "./RevisionsList.css";

export class RevisionsList extends ComponentWithRevisions {
  render() {
    if (this.props.revisions.list.length < 1) {
      return null;
    }

    return (
      <div className={styles.root}>
        {this.props.revisions.list.map(revision => {
          return (
            <RevisionsListItem
              key={revision.id}
              revisionId={revision.id}
              comment={revision.comment}
              user={revision.user}
              wordcount={revision.wordcount}
              dateCreated={revision.date_created}
              disabled={this.props.disabled}
              getBaseUrl={this.props.getBaseUrl}
            />
          );
        })}
      </div>
    );
  }
}

RevisionsList.propTypes = {
  ...ComponentWithRevisions.propTypes,
  getBaseUrl: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RevisionsList);
